import {
  ExpenseReportStatus,
  useExpenseReportsByViewQuery,
  ExpenseReportByView,
} from "@common/utils/graphql";
import { useMemo } from "react";

export const useEmployeeReportsData = (
  searchText: string,

  currentPage: number,
  status: ExpenseReportStatus[],
) => {
  const {
    loading: loadingReports,
    data: reportsData,
    refetch: refetchReports,
  } = useExpenseReportsByViewQuery({
    variables: {
      offset: currentPage * 5,
      pageSize: 5,
      expenseReportStatus: status,
      searchText: searchText || undefined,
    },
    fetchPolicy: "cache-and-network",
  });

  const hasMorePages = useMemo(() => {
    if (
      reportsData?.expenseReportsByView.__typename !==
      "QueryExpenseReportsByViewSuccess"
    ) {
      return false;
    }
    return reportsData?.expenseReportsByView.data.hasMore;
  }, [reportsData]);

  const reports = useMemo(() => {
    if (
      reportsData?.expenseReportsByView.__typename !==
      "QueryExpenseReportsByViewSuccess"
    ) {
      return [];
    }
    return reportsData?.expenseReportsByView.data
      .reports as ExpenseReportByView[];
  }, [reportsData]);

  return {
    loadingReports,
    refetchReports,
    hasMorePages,
    reports,
  };
};
